export const isPhoneNumber = (value: string): boolean => {
  const regexPhoneNumber = /^\+(?:[0-9]?){6,14}[0-9]$/;
  return regexPhoneNumber.test(value);
};
